module.exports = __webpack_public_path__ + "img/511.7491e953.jpg";